export const sortByItems = [
  {
    label: __('Recently active'),
    value: {
      sort_by: 'last_seen_at',
      order: 'desc',
    },
  },
  {
    label: __('A-Z first name'),
    value: {
      sort_by: 'firstname_with_fallback.keyword',
      order: 'asc',
    },
  },
  {
    label: __('Z-A first name'),
    value: {
      sort_by: 'firstname_with_fallback.keyword',
      order: 'desc',
    },
  },
  {
    label: __('A-Z last name'),
    value: {
      sort_by: 'lastname_with_fallback.keyword',
      order: 'asc',
    },
  },
  {
    label: __('Z-A last name'),
    value: {
      sort_by: 'lastname_with_fallback.keyword',
      order: 'desc',
    },
  },
];
